import MedicationLogistics from './MedicationLogistics';

export default MedicationLogistics;
